import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SalesForceIntegrationModels, UpdateSalesForceKeyMapBody } from "schema"
import { z } from "zod"
import { queryKey } from "../../lib/salesForce/salesForceModelMapQuery"

type Response = DataResponse<z.infer<typeof UpdateSalesForceKeyMapBody>>

export function useUpdateSalesForceKeyMapMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      body: z.infer<typeof UpdateSalesForceKeyMapBody>
      model: z.infer<typeof SalesForceIntegrationModels>
    }) => {
      const response = await axios.post<Response>(
        `/integrations/salesForce/objects/${data.model}`,
        data.body,
      )

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKey })
    },
  })
}
